import { useBooking } from '../context/BookingContext';
import { Link } from 'react-router-dom';

const BookingConfirmation = () => {
  const { bookings, currentUser } = useBooking();
  const userBookings = bookings.filter(b => b.userName === currentUser);
  const pendingBookings = userBookings.filter(b => b.status === 'pending');
  const confirmedBookings = userBookings.filter(b => b.status === 'confirmed');

  return (
    <div className="max-w-4xl mx-auto p-4">
      <h2 className="text-2xl font-bold text-green-800 mb-4">My Bookings</h2>
      <p className="text-sm text-gray-500 mb-6">Showing bookings for: <span className="font-medium text-gray-700">{currentUser}</span></p>

      {userBookings.length === 0 ? (
        <div className="bg-white p-8 rounded-lg shadow text-center">
          <p className="text-gray-500">You have no bookings yet.</p>
          <Link to="/book" className="mt-4 inline-block px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700">
            Book a Court
          </Link>
        </div>
      ) : (
        <div className="space-y-6">
          {/* Pending Bookings */}
          {pendingBookings.length > 0 && (
            <div className="bg-white shadow rounded-lg overflow-hidden">
              <div className="bg-yellow-50 px-6 py-3 border-b border-yellow-200">
                <h3 className="font-semibold text-yellow-800 flex items-center gap-2">
                  <span>⏳</span> Pending ({pendingBookings.length})
                </h3>
              </div>
              <ul className="divide-y divide-gray-200">
                {pendingBookings.map((booking) => (
                  <li key={booking.id} className="px-6 py-4">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
                      <div>
                        <p className="text-sm font-medium text-gray-900">
                          Court {booking.courtId} – {booking.date} {booking.startTime} - {booking.endTime}
                        </p>
                        <p className="text-sm text-gray-600">
                          {booking.firstName} {booking.lastName} • {booking.email || 'No email'}
                        </p>
                        {booking.address && (
                          <p className="text-sm text-gray-500">{booking.address}</p>
                        )}
                        {booking.adminNotes && (
                          <div className="mt-2 p-2 bg-gray-50 rounded text-sm text-gray-700 border border-gray-200">
                            <strong>Admin Note:</strong> {booking.adminNotes}
                          </div>
                        )}
                      </div>
                      <span className="px-3 py-1 bg-yellow-100 text-yellow-800 text-xs font-medium rounded-full whitespace-nowrap">
                        Awaiting Confirmation
                      </span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Confirmed Bookings */}
          {confirmedBookings.length > 0 && (
            <div className="bg-white shadow rounded-lg overflow-hidden">
              <div className="bg-green-50 px-6 py-3 border-b border-green-200">
                <h3 className="font-semibold text-green-800 flex items-center gap-2">
                  <span>✅</span> Confirmed ({confirmedBookings.length})
                </h3>
              </div>
              <ul className="divide-y divide-gray-200">
                {confirmedBookings.map((booking) => (
                  <li key={booking.id} className="px-6 py-4">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
                      <div>
                        <p className="text-sm font-medium text-gray-900">
                          Court {booking.courtId} – {booking.date} {booking.startTime} - {booking.endTime}
                        </p>
                        <p className="text-sm text-gray-600">
                          {booking.firstName} {booking.lastName} • {booking.email || 'No email'}
                        </p>
                        {booking.address && (
                          <p className="text-sm text-gray-500">{booking.address}</p>
                        )}
                        {booking.photoUrl && (
                          <div className="mt-2">
                            <img src={booking.photoUrl} alt="Receipt" className="h-16 w-auto rounded border" />
                          </div>
                        )}
                        {booking.adminNotes && (
                          <div className="mt-2 p-2 bg-blue-50 rounded text-sm text-gray-700 border border-blue-200">
                            <strong>📝 Admin Note:</strong> {booking.adminNotes}
                          </div>
                        )}
                      </div>
                      <span className="px-3 py-1 bg-green-100 text-green-800 text-xs font-medium rounded-full whitespace-nowrap">
                        Confirmed
                      </span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}

      <div className="mt-6 flex gap-4">
        <Link to="/" className="text-blue-600 hover:underline">← Back to Home</Link>
        <Link to="/book" className="text-green-600 hover:underline">+ Book More</Link>
      </div>
    </div>
  );
};

export default BookingConfirmation;